{
	/* Sarebbe bello mettere i bordini che si colorano di nero al click, più di uno può essere 
	selezionato e quando almeno uno di entrambi viene selezionato si può cliccare il tasto cerca 
	
	Fare difficioltà alla one-punchman
	
	Stare attenti a cosa succede sul web della tipologia*/
}
import {
	View,
	Text,
	Image,
	SafeAreaView,
	TouchableOpacity,
	ScrollView,
} from "react-native";
import React, { useLayoutEffect, useState } from "react";
import { useNavigation } from "@react-navigation/native";
import TypologyCard from "../components/TypologyCard";
import DifficultyCard from "../components/DifficultyCard";
import { AntDesign } from "@expo/vector-icons";
import { showDifficultyIt, showTopicIt } from "../utils/translation";

const difficulties = ["very-easy", "easy", "medium", "hard", "very-hard"];

const topics = ["algebra", "combinatorics", "geometry", "number-theory"];

const ProblemSearch = () => {
	const navigation = useNavigation();

	const [selectedTopic, setSelectedTopic] = useState<number | null>(null);
	const [selectedDifficulty, setSelectedDifficulty] = useState<number | null>(
		null
	);

	useLayoutEffect(() => {
		navigation.setOptions({
			headerTitleAlign: "center",
			headerStyle: {
				backgroundColor: "#263238",
			},
			headerTitleStyle: {
				color: "white",
			},
			headerTintColor: "white",
			headerShadowVisible: false,
		});
	}, []);

	return (
		<SafeAreaView className="flex-1 bg-[#263238]">
			<ScrollView className="flex-1">
				<View className="flex-1 px-2 items-center justify-center w-full max-w-screen-lg mx-auto">
					{/* <Text className="text-white text-lg text-justify">
				Seleziona l'argomento e la difficoltà del problema che vuoi
				risolvere. Se sei indeciso, non selezionare nessuna opzione e
				lascia decidere a noi!
			</Text> */}
					<View className="flex-row justify-center items-center w-full max-w-screen-lg">
						<View className="w-1/2 items-center justify-center">
							<Text className="text-white text-xl font-bold">
								Argomento
							</Text>
						</View>
						<View className="w-1/2 items-center justify-center">
							<Text className="text-white text-xl font-bold">
								Difficoltà
							</Text>
						</View>
					</View>
					<View className="flex-row justify-between items-center px-2 py-2 space-x-4 w-full max-w-screen-lg">
						<View className="flex-1 justify-between items-center w-1/2 self-start">
							{topics.map((topic, index) => {
								return (
									<TouchableOpacity
										key={index}
										className={`flex-auto justify-center ${
											[
												"bg-[#f78c6c]",
												"bg-[#009688]",
												"bg-[#ffcb6b]",
												"bg-[#c792ea]",
											][index]
										}
										 ${
												selectedTopic === index
													? "opacity-100"
													: "opacity-50"
											} rounded-lg px-2 py-2 my-2 w-full h-20`}
										onPress={() => {
											selectedTopic !== index
												? setSelectedTopic(index)
												: setSelectedTopic(null);
										}}
									>
										<Text className="text-white text-center self-center text-lg font-semibold">
											{showTopicIt(topic)}
										</Text>
									</TouchableOpacity>
								);
							})}
						</View>
						<View className="flex-1 justify-between items-center w-1/2 self-start">
							{difficulties.map((difficulty, index) => {
								return (
									<TouchableOpacity
										key={index}
										className={`flex-1 justify-center ${
											[
												"bg-[#c3e88d]",
												"bg-[#93b85d]",
												"bg-[#f78c6c]",
												"bg-[#f07178]",
												"bg-[#ff5370]",
											][index]
										}
										${
											selectedDifficulty === index
												? "opacity-100"
												: "opacity-50"
										} rounded-lg px-2 py-2 my-2 w-full h-20`}
										onPress={() => {
											selectedDifficulty !== index
												? setSelectedDifficulty(index)
												: setSelectedDifficulty(null);
										}}
									>
										<Text
											className={`text-white text-center text-lg font-semibold`}
										>
											{showDifficultyIt(difficulty)}
										</Text>
									</TouchableOpacity>
								);
							})}
						</View>
					</View>
					<TouchableOpacity
						className={
							"w-36 h-20 rounded-lg px-3 py-4 mt-10 border-2 border-[#2A373E] bg-[#1E272C] shadow-lg"
						}
						onPress={() => {
							navigation.navigate("ProblemByDifficultyAndTopic", {
								difficulty:
									selectedDifficulty !== null
										? difficulties[selectedDifficulty]
										: null,
								topic:
									selectedTopic !== null
										? topics[selectedTopic]
										: null,
							});
							setSelectedDifficulty(null);
							setSelectedTopic(null);
						}}
					>
						<View className="flex-row h-full items-center justify-center space-x-3">
							<View className="items-center justify-center">
								<Text className="text-2xl font-bold text-white">
									Cerca
								</Text>
							</View>
							<View className="items-center justify-center">
								<AntDesign
									name="search1"
									size={24}
									color="white"
								/>
							</View>
						</View>
					</TouchableOpacity>
				</View>
			</ScrollView>
		</SafeAreaView>
	);
};

export default ProblemSearch;
